import { jsx as _jsx } from "react/jsx-runtime";
import { AuthFormLocation, CookieConsentSettingState } from '@as-react/common-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NewAuthenticationPopover } from '../components/account/authentication/NewAuthenticationPopover';
import { authActions } from '../redux/authentication/actions/AuthActions.creators';
import { makeGetLoginError, makeGetLoginLoading, makeGetResetPasswordState, } from '../redux/authentication/selectors/AuthSelectors';
import { makeGetCookieConsentSettingAvailable } from '../redux/cookieConsent/selectors/CookieConsentSelector';
export const NewAuthenticationContainer = ({ actionUri, onClose, registrationLink, children, triggered, }) => {
    const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
    const dispatch = useDispatch();
    const loginError = useSelector(makeGetLoginError());
    const resetPasswordState = useSelector(makeGetResetPasswordState());
    const loading = useSelector(makeGetLoginLoading());
    const cookieConsentSettingAvailable = useSelector(makeGetCookieConsentSettingAvailable());
    const resetForgotPasswordState = () => {
        (resetPasswordState.success || resetPasswordState.error) &&
            dispatch(authActions.createResetCredentialsSuccessAction(null));
    };
    const toggleView = () => {
        setForgotPasswordActive(prev => !prev);
        resetForgotPasswordState();
    };
    const handleLoginSubmit = (values) => dispatch(authActions.login({
        username: values.email,
        password: values.password,
        keepSignedIn: values.keepSignedIn,
        reloadOnSuccess: true,
        location: AuthFormLocation.POPOVER,
    }));
    const handleClose = () => {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setTimeout(() => setForgotPasswordActive(false), 500);
    };
    useEffect(() => {
        dispatch(authActions.createInitSocialAction());
    }, []);
    return (_jsx(NewAuthenticationPopover, { login: {
            action: actionUri,
            onSubmit: handleLoginSubmit,
            errorFeedback: loginError,
            loading: loading,
        }, forgotPassword: {
            onSubmit: values => dispatch(authActions.createResetCredentialsAction(values.email)),
            errorFeedback: resetPasswordState.error,
            successFeedback: resetPasswordState.success,
        }, facebook: {}, onClose: handleClose, registrationLink: registrationLink, socialLogin: payload => dispatch(authActions.createSocialLoginAction(payload)), onAuthResetForm: () => dispatch(authActions.resetError()), forgotPasswordActive: forgotPasswordActive, toggleView: toggleView, onEmailChange: resetForgotPasswordState, cookieConsentSettingAvailable: cookieConsentSettingAvailable === CookieConsentSettingState.CONSENTS_AVAILABLE, isOpen: triggered, children: children }));
};
